import React, {useState} from 'react';

import Card from '../UI/Card';
import './IngredientForm.css';
import LoadingIndicator from "../UI/LoadingIndicator";

const IngredientForm = React.memo(props => {
    const [title, setTitle] = useState('');
    const [amount, setAmount] = useState('');

    const submitHandler = event => {
        event.preventDefault();
        props.onAddIngredient({title: title, amount: amount});
    };

    return (
        <section className="ingredient-form">
            <Card>
                <form onSubmit={submitHandler}>
                    <div className="form-control">
                        <label htmlFor="title">Name</label>
                        <input
                            id="title"
                            type="text"
                            value={title}
                            onChange={event => setTitle(event.target.value)}
                        />
                    </div>
                    <div className="form-control">
                        <label htmlFor="amount">Amount</label>
                        <input
                            id="amount"
                            type="number"
                            value={amount}
                            onChange={event => setAmount(event.target.value)}
                        />
                    </div>
                    <div className="ingredient-form__actions">
                        <button type="submit">Add Ingredient</button>
                        {props.isLoading ? <LoadingIndicator/> : null}
                    </div>
                </form>
            </Card>
        </section>
    );
});

export default IngredientForm;
